module.exports = __webpack_public_path__ + "static/img/卡片_选中状态_2@2x.ff57c257.png";